export let privateAccessType = "t1HSKd";
export default {privateAccessType};